module.exports = __webpack_public_path__ + "static/media/DivyashreeC.feeb92b0.svg";